<header class="flex bg-black h-14 app-header">
  <div class="flex justify-content-between items-center w-full mx-5">
    <div class="brand-logo">
      <a routerLink="/home" class="right_border">
        <img class="h-6 logo" src="../../../assets/icons/Deloitte_logo.svg" alt="brand_logo">
      </a>
      <p>Boardroom</p>
    </div>
    <div class="flex align-items-center justify-content-between" *ngIf="loginDisplay">
      <a class="link" routerLink="/AudioTranslation" routerLinkActive="active">Audio Translation</a>
      <a class="link" routerLink="/VoiceAnnotations" routerLinkActive="active">Voice Annotations</a>
      <a class="link" routerLink="/allfiles" routerLinkActive="active">All Files</a>
      <div  class="user-profile flex align-items-center justify-content-betweeng gap-x-2"
        (click)="menu.toggle($event)">
        <p-avatar [image]="userImage" shape="circle"></p-avatar>
      </div>
    </div>
  </div>
  <p-menu #menu [model]="profileOption" [popup]="true" class="profile-menu"></p-menu>
</header>